import { ActionPayload, ID, Part } from "../../types";
import * as types from "../constants/ActionTypes";

export interface AddChoicePayload {
  part: Part;
}
export const addChoice = (data: Part): ActionPayload<AddChoicePayload> => {
  return {
    type: types.ADD_CHOICE,
    payload: {
      part: data,
    },
  };
};

export interface RemoveChoicePayload {
  id: ID;
}
export const removeChoice = (id: ID): ActionPayload<RemoveChoicePayload> => {
  return {
    type: types.REMOVE_CHOICE,
    payload: {
      id,
    },
  };
};

export interface SetQuantityPayload {
  id: ID;
  amount: number;
}
export const setQuantity = (
  id: ID,
  amount: number
): ActionPayload<SetQuantityPayload> => {
  return {
    type: types.SET_CHOICE_QUANTITY,
    payload: {
      id,
      amount,
    },
  };
};
